/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Week_Session_Status_Athlete_PendingInputs */

const fr_week_session_status_athlete_pending = /** @type {(inputs: Week_Session_Status_Athlete_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A effectuer`)
};

/**

* @param {Week_Session_Status_Athlete_PendingInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const week_session_status_athlete_pending = /** @type {((inputs?: Week_Session_Status_Athlete_PendingInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Week_Session_Status_Athlete_PendingInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_week_session_status_athlete_pending(inputs)
});